// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: 68L0nm7Zvhiy
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateStateOnChangeProp,
  generateStateValueProp,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Email1 from "../../Email1"; // plasmic-import: swTRIky6t0do/component
import Password1 from "../../Password1"; // plasmic-import: _8NThLJuHFRw/component
import CustomErrorComponent from "../../CustomErrorComponent"; // plasmic-import: 3fSxDxNzNmO_/component
import Checkbox2 from "../../Checkbox2"; // plasmic-import: yz60bNRpJyAo/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicSignup2.module.css"; // plasmic-import: 68L0nm7Zvhiy/css
import hxDb1FtwEoXs111Cb9TCkLalCaAvifXr4Qffral7VX from "./images/hxDb1FtwEoXs111Cb9TCkLalCaAvif.avif"; // plasmic-import: Xr4qffral7vX/picture

createPlasmicElementProxy;

export const PlasmicSignup2__VariantProps = new Array();

export const PlasmicSignup2__ArgProps = new Array();

const $$ = {};

function PlasmicSignup2__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "checkAgree.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <PlasmicImg__
            data-plasmic-name={"img"}
            data-plasmic-override={overrides.img}
            alt={""}
            className={classNames(sty.img)}
            displayHeight={"90px"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={
              hasVariant(globalVariants, "screen", "mobile") ? "150px" : "179px"
            }
            loading={"lazy"}
            src={{
              src: hxDb1FtwEoXs111Cb9TCkLalCaAvifXr4Qffral7VX,
              fullWidth: 512,
              fullHeight: 512,
              aspectRatio: undefined
            }}
          />

          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__z3If1
            )}
          >
            {"Sign Up"}
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__ofkpt)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__yNhp9
              )}
            >
              {"Email"}
            </div>
            <Email1
              data-plasmic-name={"signupEmailInput"}
              data-plasmic-override={overrides.signupEmailInput}
              className={classNames("__wab_instance", sty.signupEmailInput)}
            />

            <div
              data-plasmic-name={"invalidEmailText"}
              data-plasmic-override={overrides.invalidEmailText}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.invalidEmailText
              )}
            >
              {"Invalid email address"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox___9RiqD)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__y1WuN
              )}
            >
              {"Password"}
            </div>
            <Password1
              data-plasmic-name={"signupPasswordInput"}
              data-plasmic-override={overrides.signupPasswordInput}
              className={classNames("__wab_instance", sty.signupPasswordInput)}
            />

            <CustomErrorComponent
              data-plasmic-name={"customErrorInstance"}
              data-plasmic-override={overrides.customErrorInstance}
              className={classNames("__wab_instance", sty.customErrorInstance)}
              customErrorText={
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__a42CU
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Failed to login"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Failed to login"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              }
            />
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__svpS7)}>
            <Checkbox2
              data-plasmic-name={"checkAgree"}
              data-plasmic-override={overrides.checkAgree}
              className={classNames("__wab_instance", sty.checkAgree)}
              isChecked={
                generateStateValueProp($state, ["checkAgree", "isChecked"]) ??
                false
              }
              onChange={async (...eventArgs) => {
                ((...eventArgs) => {
                  generateStateOnChangeProp($state, [
                    "checkAgree",
                    "isChecked"
                  ])(eventArgs[0]);
                }).apply(null, eventArgs);
                if (
                  eventArgs.length > 1 &&
                  eventArgs[1] &&
                  eventArgs[1]._plasmic_state_init_
                ) {
                  return;
                }
              }}
            />

            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text___6F81C
              )}
            >
              <React.Fragment>
                <React.Fragment>
                  {"By checking this box you agree to "}
                </React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__yqwn9
                    )}
                    href={"https://www.collectwise.org/terms-of-service"}
                    platform={"react"}
                    target={"_blank"}
                  >
                    {"Our Terms of Service"}
                  </PlasmicLink__>
                }

                <React.Fragment>{" and "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__gWYiV
                    )}
                    href={"https://www.collectwise.org/privacy-policy"}
                    platform={"react"}
                    target={"_blank"}
                  >
                    {"Privacy Policy"}
                  </PlasmicLink__>
                }

                <React.Fragment>{""}</React.Fragment>
              </React.Fragment>
            </div>
          </div>
          <div
            data-plasmic-name={"signupButton"}
            data-plasmic-override={overrides.signupButton}
            className={classNames(projectcss.all, sty.signupButton)}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__adVgB
              )}
            >
              {"Agree & Continue"}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "img",
    "signupEmailInput",
    "invalidEmailText",
    "signupPasswordInput",
    "customErrorInstance",
    "checkAgree",
    "signupButton"
  ],

  img: ["img"],
  signupEmailInput: ["signupEmailInput"],
  invalidEmailText: ["invalidEmailText"],
  signupPasswordInput: ["signupPasswordInput"],
  customErrorInstance: ["customErrorInstance"],
  checkAgree: ["checkAgree"],
  signupButton: ["signupButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSignup2__ArgProps,
          internalVariantPropNames: PlasmicSignup2__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSignup2__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSignup2";
  } else {
    func.displayName = `PlasmicSignup2.${nodeName}`;
  }
  return func;
}

export const PlasmicSignup2 = Object.assign(
  // Top-level PlasmicSignup2 renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    img: makeNodeComponent("img"),
    signupEmailInput: makeNodeComponent("signupEmailInput"),
    invalidEmailText: makeNodeComponent("invalidEmailText"),
    signupPasswordInput: makeNodeComponent("signupPasswordInput"),
    customErrorInstance: makeNodeComponent("customErrorInstance"),
    checkAgree: makeNodeComponent("checkAgree"),
    signupButton: makeNodeComponent("signupButton"),
    // Metadata about props expected for PlasmicSignup2
    internalVariantProps: PlasmicSignup2__VariantProps,
    internalArgProps: PlasmicSignup2__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicSignup2;
/* prettier-ignore-end */
